import { render, staticRenderFns } from "./RfDgRequestPop.vue?vue&type=template&id=2bb4c132"
import script from "./RfDgRequestPop.vue?vue&type=script&lang=js"
export * from "./RfDgRequestPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bb4c132')) {
      api.createRecord('2bb4c132', component.options)
    } else {
      api.reload('2bb4c132', component.options)
    }
    module.hot.accept("./RfDgRequestPop.vue?vue&type=template&id=2bb4c132", function () {
      api.rerender('2bb4c132', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/RfDgRequestPop.vue"
export default component.exports